<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="finalVisible"
    height="70%"
    title="导入影院"
    width="600px"
  >
    <el-form ref="importForm" :model="formData" label-width="100px">
      <!-- 影资编码导入 -->
      <el-form-item label="导入影资编码">
        <el-input
          v-model="formData.standardIds"
          :rows="5"
          placeholder="输入影资编码，多个用英文逗号隔开，系统将自动检测出影院"
          type="textarea"
        />
        <el-link type="primary" @click="handleIdentify">识别</el-link>
      </el-form-item>

      <!-- 识别结果 -->
      <div v-if="identifyResult.successNum !== 0">
        <el-card
          shadow="hover">
          <div slot="header">
            <el-icon>
              <CheckCircle/>
            </el-icon>
            <span> 识别成功 ({{ identifyResult.successNum }})(重复影院个数：{{ identifyResult.successRepeatNum }})</span>
          </div>
          <div class="result-card">
            <el-tag
              v-for="(item, index) in identifyResult.successList"
              :key="index"
              class="tag-item"
              style="margin: 4px"
              type="success"
            >
              {{ item.cinemaName }}
            </el-tag>
          </div>
        </el-card>

        <el-divider/>

        <el-card shadow="hover">
          <div slot="header">
            <el-icon>
              <CloseCircle/>
            </el-icon>
            <span> 识别失败 ({{ identifyResult.failNum }})</span>
          </div>
          <div v-if="identifyResult.failNum" class="result-card">
            <el-tag
              v-for="(failId, index) in identifyResult.failList"
              :key="index"
              class="tag-item"
              style="margin: 4px"
              type="danger"
            >
              {{ failId }}
            </el-tag>
          </div>
        </el-card>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mini from "@/api/mini";

const MiniModel = new mini();

export default {
  name: "ddCinemaManagementImportDialog",
  props: {
    cinemaMapByStandardId: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    standardIds: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        standardIds: "", // 影资编码输入
      },
      identifyResult: {
        successNum: 0, // 成功识别的数量
        failNum: 0, // 失败识别的数量
        totalNum: 0, // 总数
        // 重复数量
        successRepeatNum: 0,
        successList: [],
        failList: [],
      },
      identified: false, // 是否已经识别
    };
  },
  watch: {
    standardIds: {
      immediate: true,
      handler(val) {
        this.formData.standardIds = val;
      },
    },
    finalVisible(val) {
      if (val) {
        this.identified = false;
        this.identifyResult = {
          successNum: 0,
          failNum: 0,
          totalNum: 0,
          successRepeatNum: 0,
          successList: [],
          failList: [],
        };
        this.formData.standardIds = this.standardIds;
      }
    },
  },
  computed: {
    finalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleIdentify() {
      if (!this.formData.standardIds) {
        this.$message.error("请输入影资编码");
        return;
      }
      // c重置识别结果
      this.identifyResult = {
        successNum: 0,
        failNum: 0,
        totalNum: 0,
        successRepeatNum: 0,
        successList: [],
        failList: [],
      };
      // 预处理用户输入：去除前后空格以及末尾的逗号
      this.formData.standardIds = this.formData.standardIds
        .trim() // 去除前后空格
        .replace(/,$/, "") // 如果最后一位是逗号，去除它
        .replace(/\s*,\s*/g, ","); // 确保逗号前后没有多余空格

      const standardIds = this.formData.standardIds.split(",");
      standardIds.forEach((standardIds) => {
        const cinemaInfo = this.cinemaMapByStandardId[standardIds];
        if (cinemaInfo) {
          this.identifyResult.successList.push(cinemaInfo);
          this.identifyResult.successNum += 1;
        } else {
          this.identifyResult.failList.push(standardIds);
          this.identifyResult.failNum += 1;
        }
        this.identifyResult.totalNum += 1;
        this.identifyResult.successRepeatNum = this.identifyResult.totalNum - new Set(this.identifyResult.successList.map((item) => item.cinemaName)).size;
      });
      this.identified = true;
    },
    handleCancel() {
      // 关闭弹窗
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      // 点击确定时，检查是否已经识别
      if (!this.identified) {
        this.$message.error("请先识别后再进行保存");
        return;
      }
      // 点击确定时，将识别的结果和影资编码传递给外部组件
      this.$emit("confirm", this.identifyResult);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end; /* 按钮右对齐 */
}

.result-card {
  max-height: 200px;
  overflow-y: auto;
}

.el-link {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ddCouponExchange/ddCinemaManagement/components/ddCinemaManagementImportDialog.vue